import { catchError } from "../../utils/Helper";
import { task } from "../axios/endpoint";
import { getRequest, putRequest, postFormDataRequest } from "../axios/request";

export const getTaskReport = async (query, signal) => {
  try {
    const response = await getRequest(task.report, query, signal);
    return response?.data;
  } catch (error) {
    throw catchError(error);
  }
};

export const getBestPerformer = async (query, signal) => {
  try {
    const response = await getRequest(task.bestPerformer, query, signal);
    return response?.data;
  } catch (error) {
    throw catchError(error);
  }
};

export const getBreachAnalysis = async (query, signal) => {
  try {
    const response = await getRequest(task.breachAnalysis, query, signal);
    return response?.data;
  } catch (error) {
    throw catchError(error);
  }
};
export const getCummulativeAnalysis = async (query, signal) => {
  try {
    const response = await getRequest(task.cummulativeAnalysis, query, signal);
    return response?.data;
  } catch (error) {
    throw catchError(error);
  }
};

export const getTaskAnalyticsReport = async (query, signal) => {
  try {
    const response = await getRequest(task.taskAnalyticsReport, query, signal);
    return response?.data;
  } catch (error) {
    throw catchError(error);
  }
};

export const taskComment = async (id, payload) => {
  try {
    const response = await putRequest(task.taskComment(id),payload);
    return response?.data;
  } catch (error) {
    throw catchError(error);
  }
};
export const holdForThisMonth = async (id, formData) => {
  try {
    const response = await postFormDataRequest(task.holdForThisMonth(id), formData);
    return response?.data;
  } catch (error) {
    throw catchError(error);
  }
};

export const getReassignTaskFilterList = async (query, signal) => {
  try {
    const response = await getRequest(task.reassignTaskFilterList, query, signal);
    return response?.data;
  } catch (error) {
    throw catchError(error);
  }
};

export const taskApi = {
  getTaskReport,
  getBestPerformer,
  getBreachAnalysis,
  getCummulativeAnalysis,
  getTaskAnalyticsReport,
  taskComment,
  holdForThisMonth,
  getReassignTaskFilterList
};
